import { defineMessages } from "react-intl";

const messages = defineMessages({
    next: {
        id: "general.next",
    },
    back: {
        id: "general.back",
    },
    key: {
        id: "join.enterKey",
    },
    rememberKey: {
        id: "homework.rememberKey",
    },
});

export default messages;
